import { useState } from 'react';
import clsx from 'clsx';
import { PendingUsers } from './PendingUsers';
import { ActiveUsers } from './ActiveUsers';

type Tab = 'pending' | 'active';

export function AdminPanel() {
  const [tab, setTab] = useState<Tab>('pending');

  const tabs: Array<{ key: Tab; label: string }> = [
    { key: 'pending', label: 'Pending requests' },
    { key: 'active',  label: 'All users' },
  ];

  return (
    <div className="space-y-4">
      <div className="border-b border-border flex items-center gap-1">
        {tabs.map(t => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={clsx(
              'px-3 py-2 text-sm border-b-2 -mb-px transition-colors',
              tab === t.key
                ? 'border-accent text-accent-text font-medium'
                : 'border-transparent text-text-muted hover:text-text-secondary',
            )}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div>
        {tab === 'pending' && <PendingUsers />}
        {tab === 'active'  && <ActiveUsers />}
      </div>
    </div>
  );
}
